import {createApp} from 'vue';
import queryString from "query-string";
import axios from "axios";
import formsMixin from "@/formsMixin";

let registerFormElements = document.getElementsByClassName('RegisterForm');

if (registerFormElements.length > 0) {
    for (let i = 0; i < registerFormElements.length; i++) {
        let elementID = registerFormElements[i].id;
        let forPopup = (registerFormElements[i].dataset.forpopup === 'true');

        createApp({
            data() {
                return {
                    password: '',
                    confirmPassword: '',
                    promo: '',
                    promoHolding: '',
                    promoDescription: '',
                    couponStripePriceID: '',
                    billingFrequencyString: '',
                    showPromoBox: false,
                    promoNotValid: false,
                    validationErrorMessage: '',
                    redirectLink: undefined,
                    haveCheckedSignup: false,
                    userSignedUp: false,
                    step: 'user',
                    elements: undefined,
                    planid: '',
                    stripe: undefined,
                    cardfname: '',
                    cardlname: '',
                    forPopup: forPopup,
                }
            },
            mounted() {
              if (this.forPopup === false) {
                  this.step = 'payment';
                  this.setupStripeForm();
              }

                let params = new URLSearchParams(document.location.search);
                let promoCodeParam = params.get('promo');

                if (promoCodeParam !== null) {
                    this.showPromoBox = true;
                    this.promoHolding = promoCodeParam;
                    this.savePromoCode()
                }
            },
            mixins: [formsMixin],
            computed: {
                canSendSignup() {
                    if (this.loading === true) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.email) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.fname) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.lname) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.password) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.confirmPassword) === false) {
                        return false;
                    }
                    if (this.emailIsValid === false) {
                        return false;
                    }
                    if (this.recaptchaVerified !== true) {
                        return false;
                    }
                    if (this.passwordIsStrongEnough !== true) {
                        return false;
                    }
                    if (this.passwordsMatch !== true) {
                        return false;
                    }

                    return true;
                },
                cardFirstNameClass() {
                    if (this.validationHasRun === true) {
                        if (this.cardfname === '' || this.cardfname === undefined) {
                            return 'is-invalid';
                        } else {
                            return 'is-valid';
                        }
                    }

                    return '';
                },
                cardSecondNameClass() {
                    if (this.validationHasRun === true) {
                        if (this.cardlname === '' || this.cardlname === undefined) {
                            return 'is-invalid';
                        } else {
                            return 'is-valid';
                        }
                    }

                    return '';
                },
                planClass() {
                    if (this.validationHasRun === true) {
                        if ((this.planid === '' || this.planid === undefined) && (this.couponStripePriceID === '' || this.couponStripePriceID === undefined)) {
                            return 'is-invalid';
                        } else {
                            return 'is-valid';
                        }
                    }

                    return '';
                },
                passwordClass() {
                    if (this.validationHasRun === true) {
                        if (this.password === '' || this.password === undefined || this.passwordsMatch === false || this.passwordIsStrongEnough === false) {
                            return 'is-invalid';
                        } else {
                            return 'is-valid';
                        }
                    }

                    return '';
                },
                confirmPasswordClass() {
                    if (this.validationHasRun === true) {
                        if (this.confirmPassword === '' || this.confirmPassword === undefined || this.passwordsMatch === false) {
                            return 'is-invalid';
                        } else {
                            return 'is-valid';
                        }
                    }

                    return '';
                },
                planInputClass() {
                    if (this.couponStripePriceID !== '') {
                        return 'd-none';
                    }

                    return '';
                },
                promoCodeInputClass() {
                    if (this.showPromoBox !== true) {
                        return 'd-none';
                    }

                    return '';
                },
                addPromoCodeButtonWrapperClass() {
                    if (this.showPromoBox === true) {
                        return 'd-none';
                    }
                    if (this.promo !== '' && this.promo !== undefined && this.promo !== null) {
                        return 'd-none';
                    }

                    return '';
                },
                activePromoCodeInfoWrapperClass() {
                    if (this.promo === '' || this.promo === undefined || this.promo === null) {
                        return 'd-none';
                    }

                    return '';
                },
                passwordsMatch() {
                    return (this.password === this.confirmPassword);
                },
                passwordErrorMessage() {
                    if (this.password === '' || this.password === undefined || this.confirmPassword === '' || this.confirmPassword === undefined) {
                        return 'Password and confirm password are required';
                    }

                    if (this.passwordIsStrongEnough !== true) {
                        return 'Password should be at least 8 characters in length and should include at least one upper case letter, one number, and one special character';
                    }

                    if (this.password !== this.confirmPassword) {
                        return 'Password and confirm password must match';
                    }

                    return '';
                },
                passwordIsStrongEnough() {
                    if (this.password.match(/[a-z]+/) === false) {
                        return false;
                    }
                    if (this.password.match(/[A-Z]+/) === false) {
                        return false;
                    }
                    if (this.password.match(/[0-9]+/) === false) {
                        return false;
                    }
                    if (this.password.match(/[$@#&!]+/) === false) {
                        return false;
                    }
                    if (this.password.length < 8) {
                        return false;
                    }
                    return true;
                },
                userDetailsClass() {
                    if (this.step !== 'user') {
                        return 'd-none';
                    }

                    return '';
                },
                paymentDetailsClass() {
                    if (this.step !== 'payment') {
                        return 'd-none';
                    }

                    return '';
                },
            },
            methods: {
                setLoadingFalse(error) {
                    if (error === true) {
                        this.apiError = true;
                    }
                    this.loading = false;
                },
                setLoadingTrue() {
                    this.loading = true;
                },
                setValidationError(message) {
                    console.log('Setting validationErrorMessage to ' + message);
                    this.validationErrorMessage = message;
                },
                savePromoCode() {

                    this.promoHolding = this.promoHolding.trim();
                    this.promoHolding = this.promoHolding.toUpperCase();
                    let promoHolding = this.promoHolding;

                    const promoFormData = new FormData();
                    promoFormData.append('code', promoHolding);

                    let savePromoSuccess = this.savePromoSuccess;
                    let savePromoFailed = this.savePromoFailed;

                    axios.post('/charge/checkpromocode', promoFormData, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(async function (response) {
                        if (response.data.status === 1 && response.data.couponValid === true) {
                            savePromoSuccess(promoHolding, response.data.couponName, response.data.couponStripePriceID, response.data.billingFrequencyString);
                        } else {
                            savePromoFailed();
                        }
                    }).catch(function () {
                        savePromoFailed();
                    });
                },
                savePromoSuccess(promo, promoDescription, couponStripePriceID, billingFrequencyString) {
                    this.promo = promo.toUpperCase();
                    this.promoDescription = promoDescription;
                    this.couponStripePriceID = couponStripePriceID;
                    this.billingFrequencyString = billingFrequencyString;
                    this.showPromoBox = false;
                    this.promoNotValid = false;
                    this.planid = '';
                },
                savePromoFailed() {
                    this.promoNotValid = true;
                },
                clearPromoCode() {
                    this.promo = '';
                    this.couponStripePriceID = '';
                    this.billingFrequencyString = '';
                    this.promoDescription = '';
                    this.promoHolding = '';
                    this.showPromoBox = false;
                    this.promoNotValid = false;
                },
                inputFocus() {
                    let firstNameField = document.getElementById('RegisterFormFirstName');
                    if (firstNameField !== undefined) {
                        this.fname = firstNameField.value;
                    }
                    let lastNameField = document.getElementById('RegisterFormLastName');
                    if (lastNameField !== undefined) {
                        this.lname = lastNameField.value;
                    }
                    let emailField = document.getElementById('RegisterFormEmail');
                    if (emailField !== undefined) {
                        this.email = emailField.value;
                    }
                },
                setupStripeForm() {
                    this.stripe = Stripe(window.StripeKey);

                    const appearance = { /* appearance */};

                    this.elements = this.stripe.elements({
                        mode: 'subscription',
                        amount: 0, // 0 because of the trial
                        currency: 'gbp',
                        paymentMethodTypes: ['card'],
                        off_session: 'off_session'
                    }, appearance);

                    const options = {
                        layout: {
                            type: 'tabs',
                            defaultCollapsed: false,
                        }
                    };

                    const paymentElement = this.elements.create('payment', options);
                    paymentElement.mount('#card-element');
                },
                async sendDrySignup() {
                    await this.sendSignup(true);
                },
                async sendNonPaymentSignup() {
                    await this.sendSignup(false);
                    if (this.redirectLink !== undefined && this.redirectLink !== '') {
                        window.location.href = this.redirectLink;
                    }
                },
                async sendSignup(dry) {

                    this.validationHasRun = true;

                    await this.recaptchaVerify();

                    if (this.canSendSignup === true) {

                        this.loading = true;
                        this.apiError = false;

                        let urlParams = {
                            email: this.email,
                            fname: this.fname,
                            lname: this.lname,
                            password: this.password,
                            confirmpassword: this.confirmPassword,
                        };

                        if (dry !== true) {
                            urlParams.dry = 0;
                        } else {
                            urlParams.dry = 1;
                        }

                        let url = '/api/register?' + queryString.stringify(urlParams);

                        try {
                            return await axios.get(
                                url,
                                {
                                    headers: {
                                        'content-type': 'application/x-www-form-urlencoded'
                                    }
                                }
                            ).then((response) => {
                                let data = response.data;
                                if (data.status === 'failed') {
                                    this.apiError = true;
                                    this.errorMessage = data.errorMessage;
                                } else if (data.status === 'validationfailed') {
                                    this.apiError = false;
                                    this.validationErrorMessage = data.validationErrorMessage;
                                } else if (data.status === 'success') {
                                    this.apiError = false;
                                    this.errorMessage = '';
                                    this.validationErrorMessage = '';
                                    this.haveCheckedSignup = true;
                                    this.userSignedUp = true;
                                    this.redirectLink = data.redirectLink;
                                } else if (data.status === 'drysuccess') {
                                    this.apiError = false;
                                    this.errorMessage = '';
                                    this.validationErrorMessage = '';
                                    this.haveCheckedSignup = true;
                                    this.step = 'payment';
                                    this.validationHasRun = false;
                                    this.setupStripeForm();
                                } else {
                                    console.log('An unknown error has occurred');
                                    console.log(data);
                                    this.apiError = false;
                                    this.errorMessage = 'An unknown error has occurred';
                                    this.validationErrorMessage = '';
                                }

                                if (this.cardfname === '') {
                                    this.cardfname = this.fname;
                                }
                                if (this.cardlname === '') {
                                    this.cardlname = this.lname;
                                }

                                this.loading = false;
                                return data.status;
                            });

                        } catch (err) {
                            if (err.response) {
                                // The client was given an error response (5xx, 4xx)
                                console.log('The client was given an error response (5xx, 4xx)');
                            } else if (err.request) {
                                // The client never received a response, and the request was never left
                                console.log('The client never received a response, and the request was never left');
                            } else {
                                // Anything else
                                console.log('Other error');
                                console.log(err);
                            }
                            this.loading = false;
                            this.apiError = true;
                        }
                    }
                },
                async sendStripeForm() {

                    this.validationHasRun = true;

                    let hasValidPlan = false;

                    if (this.planid !== '' && this.planid !== undefined) {
                        hasValidPlan = true;
                    }

                    if (this.couponStripePriceID !== '' && this.couponStripePriceID !== undefined) {
                        hasValidPlan = true;
                    }

                    if (
                        hasValidPlan === true
                        && this.cardfname !== ''
                        && this.cardfname !== undefined
                        && this.cardlname !== ''
                        && this.cardlname !== undefined
                    ) {
                        this.loading = true;
                        let localfname = this.cardfname;
                        let locallname = this.cardlname;
                        let localplanid = this.planid;
                        let localcouponpriceid = this.couponStripePriceID;
                        let localemail = this.email;
                        let localpromo = this.promo;
                        let localForPopup = this.forPopup;
                        let elements = this.elements;
                        let stripe = this.stripe;
                        let sendSignup = this.sendSignup;
                        let setLoadingFalse = this.setLoadingFalse;
                        let setLoadingTrue = this.setLoadingTrue;
                        let setValidationError = this.setValidationError;

                        let needToDoSignup = true;
                        if (this.forPopup === false) {
                            needToDoSignup = false;
                        }

                        this.loading = true;

                        this.elements.submit().then(function (result) {

                            if (Object.hasOwn(result, 'error') === false) {

                                setValidationError('');

                                console.log('Stripe element submitted and valid');

                                const bodyFormData = new FormData();
                                bodyFormData.append('firstname', localfname);
                                bodyFormData.append('lastname', locallname);
                                // this isn't defined in the resubscribe form
                                if (localemail !== '' && localemail !== undefined && localemail !== null) {
                                    bodyFormData.append('email', localemail);

                                }

                                if (localcouponpriceid !== '' && localcouponpriceid !== undefined) {
                                    bodyFormData.append('promocode', localpromo);
                                } else {
                                    bodyFormData.append('planid', localplanid);
                                }

                                axios.post('/charge/intent', bodyFormData, {
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    }
                                }).then(async function (response) {

                                    console.log('Payment intent generated');

                                    const {error: submitError} = elements.submit();

                                    if (submitError) {
                                        console.log('Payment form error');
                                        setLoadingFalse();
                                        return;
                                    }

                                    console.log('Payment form submitted successfully');

                                    let signupStatus = undefined;

                                    if (needToDoSignup === true) {
                                        // Need to set here because sendSignup wont fire if we are loading normally
                                        setLoadingFalse();
                                        signupStatus = await sendSignup(false);
                                    } else {
                                        signupStatus = 'success';
                                    }

                                    if (signupStatus === 'success') {

                                        console.log('User creation successful');

                                        const resData = response.data;

                                        let status = resData.status;

                                        if (status === -1) {
                                            console.log('Error');
                                            console.log(resData);
                                            setLoadingFalse(true);
                                        } else {

                                            setLoadingTrue();

                                            let clientSecret = resData.clientSecret;
                                            let type = resData.type;
                                            let returnURL = resData.returnURL;

                                            const confirmIntent = type === "setup" ? stripe.confirmSetup : stripe.confirmPayment;

                                            // Confirm the Intent using the details collected by the Payment Element
                                            const {error} = await confirmIntent({
                                                elements,
                                                clientSecret,
                                                confirmParams: {
                                                    return_url: returnURL,
                                                },
                                            });

                                            console.log('Intent confirmed');
                                            console.log(error);

                                            if (error) {
                                                // This point is only reached if there's an immediate error when confirming the Intent.
                                                // Show the error to your customer (for example, "payment details incomplete").

                                                console.log('Payment intent confirmation failed, firing failed hook');

                                                const chargeFailedFormData = new FormData();
                                                if (localForPopup === false) {
                                                    chargeFailedFormData.append('keepuser', 1);
                                                } else {
                                                    chargeFailedFormData.append('keepuser', 0);
                                                }

                                                axios.post('/charge/failed', chargeFailedFormData, {
                                                    headers: {
                                                        'Content-Type': 'application/x-www-form-urlencoded'
                                                    }
                                                })
                                                    .then(function (response) {
                                                        const resData = response.data;
                                                        let cancelled = resData.cancelled;
                                                        if (cancelled === true) {
                                                            console.log('Failed hook fired and intent cancelled');
                                                        } else {
                                                            console.log('Failed hook fired but intent not cancelled');
                                                        }
                                                        setLoadingFalse();
                                                    })
                                                    .catch(function (error) {
                                                        console.log('Error firing failed hook');
                                                        console.log(error);
                                                        setLoadingFalse(true);
                                                    });
                                            }
                                        }

                                    } else {
                                        console.log('Problem with user creation, status is ' + signupStatus);
                                        setLoadingFalse(true);
                                    }

                                }).catch(function (error) {
                                    console.log('Failed');
                                    console.log(error);
                                    setLoadingFalse(true);
                                });

                            } else {
                                console.log('Submit invalid');
                                console.log('Result');
                                console.log(result);
                                setLoadingFalse();
                                setValidationError(result.error.message);
                            }

                        });
                    }

                },
            }
        }).mount('#' + elementID);
    }
}